import { z } from 'zod';
import { CaseIdSchema, IsoTimestampSchema, SourceIdSchema, UserIdSchema } from './common.js';

export const SourceTypeSchema = z.enum([
  'm365',
  'whatsapp',
  'gmail',
  'imap',
  'pst',
  'mbox',
  'eml',
  'sms_backup',
  'iphone_backup',
  'document_upload',
]);
export type SourceType = z.infer<typeof SourceTypeSchema>;

export const SourceStatusSchema = z.enum(['pending', 'importing', 'completed', 'failed']);
export type SourceStatus = z.infer<typeof SourceStatusSchema>;

export const SourceSchema = z.object({
  id: SourceIdSchema,
  caseId: CaseIdSchema,
  type: SourceTypeSchema,
  navn: z.string().min(1, 'Kildenavn kan ikke være tomt'),
  status: SourceStatusSchema,
  importStart: IsoTimestampSchema.optional(),
  importEnd: IsoTimestampSchema.optional(),
  owner: UserIdSchema,
  /** Friform metadata fra kilden – valideres nærmere av parseren */
  metadata: z.record(z.string(), z.unknown()),
});

export type Source = z.infer<typeof SourceSchema>;
